
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 10.5c0 5.192 3.792 9.508 8.75 10.383l.058-.046-.058-.012v-7.408H6.125V10.5H8.75V8.167c0-2.625 1.692-4.083 4.083-4.083.759 0 1.575.116 2.334.233V7h-1.342c-1.283 0-1.575.642-1.575 1.459V10.5h2.8l-.467 2.917H12.25v7.408l-.058.012.058.046C17.208 20.008 21 15.692 21 10.5 21 4.725 16.275 0 10.5 0S0 4.725 0 10.5z","fill":"#fff"}})])
          )
        }
      }
    